// extracted by mini-css-extract-plugin
export var statItem = "_k9-1";
export var statsRow = "_k9-0";